import ServicesList from "components/car/ServicesList"
import { useContext } from "react"
import { CarContext } from "../CarContext"

export default function Services() {
  const { car } = useContext(CarContext)

  return <ServicesList car={car} />
}
